import type {
  BootstrapData,
  BootstrapDashboard,
  BootstrapLimits,
  BootstrapPlan,
  BootstrapUsage,
} from '@/app/(app)/context/BootstrapContext'

/** Map GET /api/portal/session `bootstrap` object into BootstrapContext shape. */
export function portalSessionBootstrapToData(raw: unknown): BootstrapData | null {
  if (!raw || typeof raw !== 'object') return null
  const d = raw as Record<string, unknown>
  if (d.sessionReady !== true || d.planResolution !== 'known') return null
  const plan = d.plan
  if (!plan || typeof plan !== 'object') return null
  return {
    sessionReady: true,
    billingActive: d.billingActive !== false,
    plan: plan as BootstrapPlan,
    planNormalized: typeof d.planNormalized === 'string' ? d.planNormalized : 'free',
    planResolution: 'known',
    features: typeof d.features === 'object' && d.features !== null ? (d.features as Record<string, boolean>) : {},
    usage: (d.usage ?? null) as BootstrapUsage | null,
    limits: d.limits as BootstrapLimits,
    dashboard: (d.dashboard as BootstrapDashboard | null) ?? null,
    dashboardDefaultRange:
      d.dashboardDefaultRange && typeof d.dashboardDefaultRange === 'object'
        ? (d.dashboardDefaultRange as BootstrapData['dashboardDefaultRange'])
        : null,
    adminAllowed: d.adminAllowed === true,
  }
}
